import {fetch, normalize} from "utils/dataAccess";

import persist from "./persister";

import {setEshopConfig} from "utils/dataAccessOrganizationHandler";
import {ShippingMethodsDiscr} from "utils/ShippingMethods";

export function create(values) {
    if (!values) {
        return;
    }
    values = persist(values);

    setEshopConfig(values);

    let url = '/shipping_methods'

    if (values.discr) {
        if (ShippingMethodsDiscr.toArray().includes(values.discr)) {
            url = `${url}/${values.discr}`
        }
    }

    return new Promise((resolve, reject) => {
        fetch(url, {
            method: "POST",
            body: JSON.stringify(values),
        }).then(response => response.json()).then((retrieved) => {
            resolve(normalize(retrieved));
        }).catch(error => reject(error.message));
    });
}
